import * as React from 'react';
import classNames from 'classnames';
import AntMenu from 'antd/lib/menu';
import { MenuProps as AntMenuProps } from 'antd/lib/menu';
// import AntMenuItem from 'antd/lib/menu/MenuItem';
import MenuItem from './MenuItem';

import styles from './Menu.module.scss';

export interface MenuProps extends AntMenuProps {}

export class Menu extends React.Component<MenuProps, {}> {
	static Item: typeof MenuItem;

	render() {
		return (
			<AntMenu {...this.props} className={classNames(this.props.className, styles.root)} />
		);
	}
}

Menu.Item = MenuItem;

export default Menu;
